module.exports = __webpack_public_path__ + "img/phone.eda76812.png";